import * as React from "react";
import autobind from "autobind-decorator";
import { Store } from "./store";
import { observer } from "mobx-react";
import {
	ControlWrapper,
	ControlButton,
	ControlPageCount,
} from "./components";
import { GN } from "@lib/common";

interface Props<T> {
	store: Store<T>;
	onPageChange?: (page: number) => void;
}
interface State {
	pageInput: string;
}

@observer
export class ProtableControls<T> extends React.Component<Props<T>, State> {

	timeout: number | undefined;

	constructor(props: Props<T>) {
		super(props);
		this.state = {
			pageInput: "1"
		};
	}

	changePage = (forward: boolean) => {
		const { store, onPageChange } = this.props;
		const s = store.s;
		if (forward) {
			if (s.page + 1 <= store.totalPages) {
				const page = s.page + 1;
				if (onPageChange) onPageChange(page);
				store.setPage(page);
				this.setState({
					pageInput: page.toString()
				});
			}
		}
		else if (s.page - 1 >= 1) {
			const page = s.page - 1;
			if (onPageChange) onPageChange(page);
			store.setPage(page);
			this.setState({
				pageInput: page.toString()
			});
		}
	}

	setFirstPage = () => {
		const { store, onPageChange } = this.props;
		const s = store.s;
		if (s.page !== 1) {
			if (onPageChange) onPageChange(1);
			store.setPage(1);
			this.setState({
				pageInput: "1"
			});
		}
		
	}

	setLastPage = () => {
		const { store, onPageChange } = this.props;
		const s = store.s;
		if (s.page !== store.totalPages) {
			if (onPageChange) onPageChange(store.totalPages);
			store.setPage(store.totalPages);
			this.setState({
				pageInput: store.totalPages.toString()
			});
		}
	}

	componentWillUnmount(): void {
		if(this.timeout) {
			if (this.timeout) {
				window.clearTimeout(this.timeout);
			}
		}
	}

	render() {
		const { store, onPageChange} = this.props;
		const { pageInput } = this.state;
		const s = store.s;
		return (
			<ControlWrapper>
				<ControlButton onClick={this.setFirstPage}>First</ControlButton>
				<ControlButton onClick={() => this.changePage(false)}>Previous</ControlButton>
				<ControlPageCount>
					<input
						type="number"
						value={pageInput}
						max={store.totalPages}
						step={1}
						min={1}
						onChange={(e) => {
							const { value } = e.target;
							this.setState({
								pageInput: value
							});
							clearTimeout(this.timeout);
							this.timeout = setTimeout(() => {
								if (value === "") return;
      							const page = Number(value);
								if(!Number.isNaN(page) && page >= 1 && page <= store.totalPages) {
									onPageChange?.(page);
									store.setPage(page);
								} else {
									GN.add({
										type: "warning",
										duration: 1000,
										message: "Invalid page number"
									});
								}
							}, 500);
							
						}}
						onBlur={() => {
							if(pageInput === "") {
								this.setState({
									pageInput: String(s.page)
								})
							}
						}}/>
					/ {store.totalPages}
				</ControlPageCount>
				<ControlButton onClick={() => this.changePage(true)}>Next</ControlButton>
				<ControlButton onClick={this.setLastPage}>Last</ControlButton>
			</ControlWrapper>
		);
	}

}
